import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFieldVp = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={630}
        height={844}
        fill="none"
        viewBox="0 0 630 844"
        {...props}
    >
        <path fill="#2B632D" d="M4 4.038h620v83.794H4z" />
        <path fill="#367C38" d="M4 87.832h620v83.794H4z" />
        <path fill="#2B632D" d="M4 171.627h620v83.794H4z" />
        <path fill="#367C38" d="M4 255.421h620v83.794H4z" />
        <path fill="#2B632D" d="M4 339.215h620v83.794H4z" />
        <path fill="#367C38" d="M4 423.01h620v83.794H4z" />
        <path fill="#2B632D" d="M4 506.804h620v83.794H4z" />
        <path fill="#367C38" d="M4 590.598h620v83.794H4z" />
        <path fill="#2B632D" d="M4 674.392h620v83.794H4z" />
        <path fill="#367C38" d="M4 758.186h620v83.794H4z" />
        <path
            stroke="#fff"
            strokeOpacity={0.2}
            strokeWidth={4}
            d="M454.5 837.943V716.794h-94m-186 121.149V716.794h94m0 0c10.116-14.677 26.947-24.21 46-24.21 18.743 0 35.835 9.936 46 24.21m-92 0h92M22.222 837.943A10.07 10.07 0 0 0 24.146 832c0-5.52-4.398-9.994-9.823-9.994-1.962 0-3.79.585-5.323 1.593m13.222 14.344H9v-14.344m13.222 14.344H251.5M9 823.599V8.077h242m355.624 829.86a10 10 0 0 1-1.947-5.943c0-5.519 4.449-9.994 9.938-9.994a9.85 9.85 0 0 1 5.385 1.593M22.222 8.156a10.07 10.07 0 0 1 1.924 5.943c0 5.52-4.398 9.994-9.823 9.994A9.66 9.66 0 0 1 9 22.5M606.778 8.656a10.07 10.07 0 0 0-1.924 5.943c0 5.52 4.398 9.994 9.823 9.994A9.66 9.66 0 0 0 620 23M454 8.077v121.148h-94M174 8.077v121.148h94m0 0c10.116 14.677 26.947 24.21 46 24.21 18.743 0 35.835-9.936 46-24.21m-92 0h92M251 8.077v47.942h128V8.077m-128 0h128m0 0h241v829.866H379.5m-128 0h128m-128 0V790h128v47.943M10 423.514h610m-246-.505c0 33.454-26.863 60.574-60 60.574s-60-27.12-60-60.574 26.863-60.574 60-60.574 60 27.12 60 60.574Z"
        />
        <path fill="#5E9660" d="M314 429.115c3.314 0 6-2.712 6-6.058h-12c0 3.346 2.686 6.058 6 6.058" />
        <path fill="#558257" d="M314 417c3.314 0 6 2.712 6 6.057h-12c0-3.345 2.686-6.057 6-6.057" />
    </svg>
);
export default SvgFieldVp;
